import { Network as Connector } from "@web3-react/network";
import { useConnector, useInitializeConnector, useSwitchChain } from "../hooks";
import { useCallback, useEffect } from "react";
import { BaseConnectorProps } from "./types";
import { Web3ConnectionType } from "../types";

export const Network = ({
  options,
  onStateUpdate,
  chainId,
  onConnectorUpdate,
}: BaseConnectorProps<Connector>) => {
  const connector = useInitializeConnector(
    Web3ConnectionType.NETWORK,
    useCallback(
      (actions) => {
        return new Connector({ actions, urlMap: options.urls });
      },
      [options.urls],
    ),
  );

  useEffect(() => {
    onConnectorUpdate(connector.connector);
  }, [connector.connector, onConnectorUpdate]);

  const state = useConnector(connector, onStateUpdate);

  useSwitchChain(connector.connector, state, chainId || options.defaultChainId);

  return null;
};
